import './src/amplify-init'
import './src/styles/global.css'

import FunnelModal from './src/components/FunnelModal'
import VideoModal from './src/components/VideoModal'
import { FunnelModalProvider } from './src/contexts/FunnelModalContext'
import { VideoModalProvider } from './src/contexts/VideoModalContext'
import { ExperimentsProvider, startExperiments } from './src/experiments'
import { isBrowser } from './src/utils'

export const wrapRootElement = ({ element }) => (
  <ExperimentsProvider>
    <FunnelModalProvider>
      <VideoModalProvider>
        {element}
        <FunnelModal />
        <VideoModal />
      </VideoModalProvider>
    </FunnelModalProvider>
  </ExperimentsProvider>
)

export const onClientEntry = () => {
  if (!isBrowser) return

  // Flags so frueh wie moeglich laden, damit sie meist vor dem Timeout da sind
  startExperiments()

  const initMetaPixel = () => {
    if (window.fbq && window.fbq.loaded) return

    /* eslint-disable no-unused-expressions */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    )
    /* eslint-enable no-unused-expressions */
    window.fbq('init', '4381921388799342')
    window.fbq('track', 'PageView')
  }

  const hasAnalyticsConsent = (state) => {
    if (!state || state.action !== 'accept') return false
    const categories = state.categories || []
    return (
      categories.includes('analytics') ||
      categories.includes('performance') ||
      categories.includes('statistics') ||
      categories.length === 0 // accept all
    )
  }

  const hasMarketingConsent = (state) => {
    if (!state || state.action !== 'accept') return false
    const categories = state.categories || []
    return (
      categories.includes('targeting') ||
      categories.includes('marketing') ||
      categories.includes('performance') ||
      categories.length === 0 // accept all
    )
  }

  // Prevent duplicate consent events using sessionStorage
  const trackConsentOncePerPage = (action, categories = []) => {
    const key = `consent_tracked_${action}`
    if (window.sessionStorage.getItem(key)) return

    window.sessionStorage.setItem(key, '1')

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'cookie_consent',
      consent_action: action,
      consent_categories: categories.join(',')
    })
  }

  window.addEventListener('CookieScriptAcceptAll', () => {
    trackConsentOncePerPage('accept_all')
    initMetaPixel()
    window.clarity?.('consent')
    console.log('[Clarity] Consent granted (accept all) — Clarity is active')
  })

  window.addEventListener('CookieScriptAccept', (e) => {
    const categories = e.detail?.categories || []
    trackConsentOncePerPage('accept_categories', categories)

    if (
      categories.includes('targeting') ||
      categories.includes('marketing') ||
      categories.includes('performance')
    ) {
      initMetaPixel()
    }

    if (hasAnalyticsConsent({ action: 'accept', categories })) {
      window.clarity?.('consent')
      console.log('[Clarity] Consent granted (category accept) — Clarity is active')
    }
  })

  window.addEventListener('CookieScriptReject', () => {
    trackConsentOncePerPage('reject_all')
  })

  window.addEventListener('CookieScriptClose', () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'cookie_banner_closed' })
  })

  window.addEventListener('CookieScriptLoaded', () => {
    const state = window.CookieScript?.instance?.currentState?.()

    const hasConsentDecision =
      state &&
      typeof state.action === 'string' &&
      (state.action === 'accept' || state.action === 'reject')

    if (hasMarketingConsent(state)) initMetaPixel()
    if (hasAnalyticsConsent(state)) {
      window.clarity?.('consent')
      console.log('[Clarity] Consent restored from cookie — Clarity is active')
    }

    if (!hasConsentDecision) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: 'cookie_banner_shown' })
    }
  })
}
